import type { Catalogs, Translate, Translation } from "@amtana/i18n/catalog";

// The scoring screen's own words (S8.04, the seeded "lead-scoring" flag's real gated
// surface): one key per string, in English and Spanish. A key with no Spanish entry
// falls back to English (packages/i18n's own rule).

export type ScoringCopyKey = keyof typeof EN;
export type ScoringCatalog = typeof EN;

const EN = {
  breadcrumbHome: "Home",
  breadcrumbScoring: "Scoring",
  screenTitle: "Scoring · {product}",
  title: "Scoring",
  description: "Prospects ranked by how likely they are to convert, highest first.",
  columnName: "Name & username",
  columnScore: "Score",
  emptyTitle: "No prospects yet",
  emptyDescription: "Run an analysis to see prospects ranked by their score.",
} as const;

const ES: Translation<ScoringCatalog> = {
  breadcrumbHome: "Inicio",
  breadcrumbScoring: "Puntuación",
  screenTitle: "Puntuación · {product}",
  title: "Puntuación",
  description: "Prospectos ordenados por probabilidad de conversión, de mayor a menor.",
  columnName: "Nombre y usuario",
  columnScore: "Puntuación",
  emptyTitle: "Todavía no hay prospectos",
  emptyDescription: "Ejecuta un análisis para ver prospectos ordenados por su puntuación.",
};

export const SCORING_CATALOGS: Catalogs<ScoringCatalog> = { en: EN, es: ES };

/** The score as the user reads it: a dash until a prospect has one. */
export function scoreText(score: number | undefined): string {
  return score === undefined ? "-" : String(score);
}

export type ScoringCopy = Translate<ScoringCatalog>;
